module.exports = __webpack_public_path__ + "static/media/ML.c931aaa1.svg";